module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.authenticated) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_vm._m(0), _vm._v(" "), _c('top-buttons')], 1), _vm._v(" "), _c('aside', {
    staticClass: "hidden-print",
    attrs: {
      "id": "left-panel"
    }
  }, [_c('login-info'), _vm._v(" "), _c('nav-left')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto !important"
    },
    attrs: {
      "id": "main",
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "hidden-print",
    attrs: {
      "id": "ribbon"
    }
  }, [_c('breadcrumb'), _vm._v(" "), (this.$router.history.current.path !== '/') ? _c('span', {
    staticClass: "ribbon-button-alignment pull-right"
  }, [_c('span', {
    staticClass: "btn btn-ribbon",
    attrs: {
      "data-title": "search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.bus.$emit('breadcrumb-search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Pesquisar")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    attrs: {
      "clas": "row"
    }
  }, [_c('message', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('router-view')], 1)])]), _vm._v(" "), _c('page-footer')], 1) : _c('div', [_c('login-page')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "logo-group"
    }
  }, [_c('span', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/template/img/logo-pale.jpg",
      "width": "100%",
      "alt": "MSB Tech"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8399f25c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1049
// module chunks = 1